export const LOGIN_ROUTE = 'logowanie';
export const FORGOT_PASSWORD_ROUTE = 'zapomnialem-hasla';
export const RESET_PASSWORD_ROUTE = 'nowe-haslo/:token';
